export var Key;
(function (Key) {
    Key["ORDER"] = "STATE";
    Key["MAKER_INDEX"] = "MAKER_INDEX";
    Key["DATE_INDEX"] = "DATE_INDEX";
    Key["BEST_BY_QUOTE_INDEX"] = "BEST_BY_QUOTE_INDEX";
    Key["ACTIVE_INDEX"] = "ACTIVE_INDEX";
    Key["CLOSED_INDEX"] = "CLOSED_INDEX";
    Key["ERROR_INDEX"] = "ERROR_INDEX";
    Key["UNIQUENESS_CHECK"] = "UNIQUENESS_CHECK";
    Key["L1_TX_INFO"] = "L1_TX_INFO";
    Key["INCREMENT_INDEX"] = "INCREMENT_INDEX";
})(Key || (Key = {}));
export var ACTIVITY_STATUS;
(function (ACTIVITY_STATUS) {
    ACTIVITY_STATUS["ACTIVE"] = "ACTIVE";
    ACTIVITY_STATUS["COMPLETED"] = "COMPLETED";
    ACTIVITY_STATUS["CANCELLING"] = "CANCELLING";
    ACTIVITY_STATUS["CANCELLED"] = "CANCELLED";
    ACTIVITY_STATUS["EXPIRED"] = "EXPIRED";
    ACTIVITY_STATUS["ERROR"] = "ERROR";
})(ACTIVITY_STATUS || (ACTIVITY_STATUS = {}));
export var PUBLIC_METHODS;
(function (PUBLIC_METHODS) {
    PUBLIC_METHODS["CREATE_ORDER"] = "CREATE_ORDER";
    PUBLIC_METHODS["CANCEL_ORDER"] = "CANCEL_ORDER";
})(PUBLIC_METHODS || (PUBLIC_METHODS = {}));
export const FEE = {
    CREATE_ORDER: (iterations) => 500000n /*common*/ +
        (4500n /*jump-listener iteration*/ + /*handle trigger iteration*/ 85000n) * BigInt(iterations ?? 1_000_000),
    CANCEL_ORDER: 500000n,
};
export var AddressEncoding;
(function (AddressEncoding) {
    AddressEncoding["Hex"] = "0x00";
    AddressEncoding["Base58"] = "0x01";
    AddressEncoding["Bech32"] = "0x02";
    AddressEncoding["Bech32m"] = "0x03";
})(AddressEncoding || (AddressEncoding = {}));
const BTC_MAIN_NET = {
    bech32: 'bc',
    scriptHash: 0x05,
    publicKeyHash: 0x00,
};
const BTC_TEST_NET = {
    bech32: 'tb',
    scriptHash: 0xc4,
    publicKeyHash: 0x6f,
};
const LTC_MAIN_NET = {
    bech32: 'ltc',
    scriptHash: 0x32,
    publicKeyHash: 0x30,
};
const LTC_TEST_NET = {
    bech32: 'tltc',
    scriptHash: 0x3a,
    publicKeyHash: 0x6f,
};
const DOGE_MAIN_NET = {
    bech32: '',
    scriptHash: 0x16,
    publicKeyHash: 0x1e,
};
const DOGE_TEST_NET = {
    bech32: '',
    scriptHash: 0xc4,
    publicKeyHash: 0x71,
};
export const BtcLikeNetworkParams = {
    btc: BTC_MAIN_NET,
    tbtc: BTC_TEST_NET,
    ltc: LTC_MAIN_NET,
    tltc: LTC_TEST_NET,
    dog: DOGE_MAIN_NET,
    tdog: DOGE_TEST_NET,
};
/**
 * !IMPORTANT! Order of values in the array is crucial
 */
export const OrderBatchFields = [
    'l1Amount',
    'l1Address',
    'minL1Amount',
    'baseAmount',
    'chainData',
    'maxUses',
];
